// Supplier-facing contact details for the portal slide-out (Help & Contact
// tab) and help articles.
//
// SINGLE SOURCE: these details now derive from PORTAL_CONTACT (portalContact.js)
// so the drawer, help articles and the footer can never drift apart — there is
// one place to change the email, number or hours (account brief §5 / tech-debt
// 4.1). This module just re-shapes those values into the field names its
// existing consumers expect. phoneFormatted is the tel: target (international
// dial format); phoneDisplay is what the user reads.
import { PORTAL_CONTACT } from './portalContact';

const { email, phone, phoneDial, hours } = PORTAL_CONTACT.partnerSupport;

export const FUSION_CONTACT = {
  email,
  phoneDisplay: phone,
  phoneFormatted: phoneDial,
  hours,
};

// Light UK phone formatter for display (build #18 §4b). Groups a plain
// 11-digit UK number for readability — 01/07 → "01234 567890", 02x →
// "020 1234 5678" — so stored numbers like "01234567889" read consistently
// with the support line. Leaves already-spaced or non-standard values as
// entered, so it won't mangle extensions or international numbers.
export const formatUkPhone = (raw) => {
  if (raw == null) return raw;
  const s = String(raw).trim();
  if (!s) return s;
  const digits = s.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('0')) {
    if (digits.startsWith('02')) return `${digits.slice(0, 3)} ${digits.slice(3, 7)} ${digits.slice(7)}`;
    return `${digits.slice(0, 5)} ${digits.slice(5)}`;
  }
  return s;
};
